// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  azure: {
    sas: '?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2030-12-18T18:53:42Z&st=2020-12-18T10:53:42Z&spr=https&sig=dJaThqno1ojGsKq4e2aNrSRU6TojCMiMwKw95vsv60k%3D',
    storageAccount: 'avtopiablob',
    containerName: 'avtopia',
  },
  firebaseConfig: { //production key
    apiKey: "AIzaSyAkNpwC-YPeAibsdxPOtX-bmPQiFyRo09g",
    authDomain: "avtopia-app.firebaseapp.com",
    databaseURL: "https://avtopia-app-default-rtdb.firebaseio.com",
    projectId: "avtopia-app",
    storageBucket: "avtopia-app.firebasestorage.app",
    messagingSenderId: "482498302645",
    appId: "1:482498302645:web:df8b17ea0022d58deaa4fc",
    measurementId: "G-EHQ2TNV1SG"
  },
  // firebaseConfig: {
  //   apiKey: "AIzaSyDJMMC48pgDKvuc93o4uuyU_H0IHvkHei0",
  //   authDomain: "avtopia-e447d.firebaseapp.com",
  //   databaseURL: "https://avtopia-e447d.firebaseio.com",
  //   projectId: "avtopia-e447d",
  //   storageBucket: "avtopia-e447d.appspot.com",
  //   messagingSenderId: "113703349449",
  //   appId: "1:113703349449:web:9167399c11eacaf686f118"
  // },
  linkedInConfig: {
    linkedInAuthUrl: 'https://www.linkedin.com/oauth/v2/authorization',
    // redirect_uri: 'http://localhost:4200/account/login',//local development
    redirect_uri: 'https://avtopia.com/account/login',//production
    // redirect_uri: 'https://avtopia-web.previewbay.com/account/login',
    response_type: 'code',
    state: 'DCEeFWf45A53sdfKef424',
    client_id: '86zkxujdyuamw5',
    scope: 'openid%20profile%20email',
    // scope: 'r_liteprofile',
    clientSecret: 'WPL_AP1.YSulQWD7EMLR1JNF.mf1ITA=='
  },
  panelUrl: 'https://avtopia.com',
  googleAPI: 'https://maps.googleapis.com/maps/api/geocode',
  googleClientId: '113703349449-4eulddlrk4cpi40glfvk2c98mjp761ni.apps.googleusercontent.com',
  googleClientSecret: 'iSjSnAmYbyVEwcA-TxbWYENl',
  FINGER_PRINT: "Basic YW9nOmFvZ0AxMjM=",
  facebookAppId: '260630981597692',
  MAP_API_KEY: "AIzaSyAbsOHGbBdGA28ziB-AwWZ6PwTGDL9hhXM",//production key
  // MAP_API_KEY: "AIzaSyDbcwq4lXkpO5BdQMhqfI0pkgAndcckHqU",//development key
  captchaSiteKey: '6LcntPQZAAAAAGRJhAhDMzb_b6q7bm4k9Rl4AHL6',
  captchaSecretKey: '6LcntPQZAAAAAOg2qujkDjW7-bFl5T5C19F1Wx6H',
  captchaScriptSrc: 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit',
  // apiBaseUrl: 'https://avtopiaqaapi.appskeeper.com/avtopia/api/v1',
  // apiBaseUrl: 'http://localhost:3000/avtopia/api/v1',
  // apiBaseUrl: 'https://avtopia-backend.previewbay.com/avtopia/api/v1',
  apiBaseUrl: 'https://api.avtopia.com/avtopia/api/v1',
  // Dev Basic Auth (if your local backend prompts with WWW-Authenticate)
  devBasicAuthEnabled: false,
  devBasicAuthUser: '',
  devBasicAuthPass: '',
  // API_KEY: "1234",
  // MAP_API_KEY: "AIzaSyAQAm_7N_IQ8ItgJFiAFuHOnRnnNRP4P4w",
  tokenRememberKey: 'remember',
  tokenKey: 'session_tok',
  currentEnv: 'dev',
  accessSecrets: {
    siteUserName: 'avtopiabetauser',
    secreteKey: 'aog@appinventiv',
    //md5 hash
    secretKeyText: 'tH6?Y1*iBGC.,pwP'
  },
  socialLinks: {
    facebook: 'https://www.facebook.com/avtopia',
    linkedIn: 'https://www.linkedin.com/company/avtopia',
    twitter: 'https://twitter.com/avtopia',
    instagram: 'https://www.instagram.com/avtopia_/',
    snapchat: 'https://www.snapchat.com/add/avtopiaaog',
    tiktok: 'https://www.tiktok.com/@avtopia',
    google: 'info@avtopia.com',
    address: '2604-B El Camino Real, Suite 109, Carlsbad CA 92008'
  },
  //   Hash: 6cde6098a76f84f897 c9df18e00b0351
  // String: aog@appinventiv

  //Comet Chat credentials
  cometChatConfig: {
    // appId: '16723437111895f79',
    // authKey: '13554fe1bf3097d2bad5a428016292ddb7243dde',
    appRegion: 'in',
    appId: '1671774cd696e2f62',
    authKey: '2625033db0451fafb84ff75fe9d719a91208251d',
    fcmProviderId: 'avtopia-fcm', // Add your FCM Provider ID from CometChat Dashboard -> App Settings -> Push Notifications
  }
};
